import { escapeReceiptHtml } from './format';

export function pickupTrackingUrl(url?: string | null): string | null {
  const t = url?.trim();
  return t || null;
}

export function pickupTrackingQrLabel(fulfillmentLabel?: string | null): string {
  if (fulfillmentLabel?.trim() === 'Comer acá') {
    return 'Escaneá el QR — te avisamos cuando esté listo.';
  }
  return 'Escaneá el QR — seguí tu pedido acá.';
}

export function pickupTrackingQrHtml(url: string, caption: string): string {
  const enc = encodeURIComponent(url);
  return `<img src="https://api.qrserver.com/v1/create-qr-code/?size=160x160&amp;data=${enc}" alt="" style="width:40mm;"/><div class="caption">${escapeReceiptHtml(caption)}</div>`;
}
